define(function() {
	const IpsModel = require('civicsBase/ipsModel');
	const IpsCollection = require('civicsBase/ipsModelCollection');
	const utils = require('civicsUtils/general_utilities');
	const constraint_parser = require('civicsUtils/constraint_parser');
	const view_manager = require('civicsUtils/view_manager');
	const CN = require('civicsUtils/constants');
	const AvailableFeatures = require('civicsUtils/available_features');
	const attachment_utilities = require('civicsUtils/attachment_utility');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/',
		instrumentUrls: {
			building: 'cdr/applications/Building/',
			businesslicense: 'cdr/applications/BusinessLicense/',
			codeenforcement: 'cdr/applications/CodeEnforcement/',
			planning: 'cdr/applications/Planning/',
			project: 'cdr/applications/Project/',
			tradelicense: 'cdr/applications/TradeLicense/',
			use: 'cdr/applications/Use/',
			servicerequest: 'crm/ServiceRequests/',
			servicerequestbilling: 'crm/account/{0}/ServiceRequests/',
		},
		instrumentUrls2: { //for multifile upload
			building: 'reroute/multipart/cdr/applications/Building/',
			businesslicense: 'reroute/multipart/cdr/applications/BusinessLicense/',
			codeenforcement: 'reroute/multipart/cdr/applications/CodeEnforcement/',
			planning: 'reroute/multipart/cdr/applications/Planning/',
			project: 'reroute/multipart/cdr/applications/Project/',
			tradelicense: 'reroute/multipart/cdr/applications/TradeLicense/',
			use: 'reroute/multipart/cdr/applications/Use/',
		},
		url: function() {
			var retVals = [];
			var retVal = '';
			if (this.instrumentType) {
				if (this.instrumentType.toLowerCase() == 'servicerequest') {
					retVal = this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()];
				} else if (this.instrumentType.toLowerCase() == 'servicerequestbilling') {
					//TODO - Add accountId null value check.  Not sure what we want to do if it is null
					var accountId = this.accountId ? this.accountId : this.get("accountId");
					retVal = this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()].format(accountId);
				} else {
					var cdrURL = this.supportsMultiFiles ? this.instrumentUrls2[this.instrumentType.toLowerCase()] :
					this.instrumentUrls[this.instrumentType.toLowerCase()];
					retVal = this.urlRoot + cdrURL;
				}

				if (this.id) {
					retVal += this.id;
				}
			}
			if (this.dynamicBinds && this.dynamicMoniker) {
				var selects;
				_.forEach(this.dynamicBinds, b => {
					selects = !selects ? b : selects + ',' + b;
				});

				var propertyId = '';
				if (this.dynamicPropertyId && this.dynamicPropertyId.trim().length > 0) {
					propertyId = this.dynamicPropertyId + '.';
				}
				retVals.push('Select={2}${0}({1})'.format(this.dynamicMoniker, selects, propertyId));

			}
			if(Array.isArray(this.selects) && this.selects.length>0){
				retVals.push('Select=['+this.selects.join(',')+']');
			}
			if (this.includeAttachments) {
				retVals.push('IncludeAttachments=' + this.includeAttachments);

			}

			if(this.includeconstraints) {
				retVals.push('includeconstraints='+this.includeconstraints);
			}

			if(AvailableFeatures.ElectronicPlanForCustomers() && !this.isPortalProject && this.id) {
				retVals.push('indicateeplanenabled=true');
			}

			if (this.hasSteps) {
				retVals.push('HasSteps=' + this.hasSteps);
			}
			//If service request and POST, then add UseRequestTypeDefaults
			if((this.instrumentType.toLowerCase() === "servicerequest" || this.instrumentType.toLowerCase() === "servicerequestbilling") && this.id == null ){
				if( AvailableFeatures.UseRequestTypeDefaults() === true ){
					retVals.push( 'UseRequestTypeDefaults=true' );
				}
			}
			if(retVals.length>0){
				retVal+='?'+retVals.join('&');
			}

			return retVal;
		},
		//attrs contains key/value of model data
		//key: model attribute name
		//value: model attribute value
		// validate: function (attrs, options) {
		//     //errors object to hold error messages.
		//     //key: portion of jQuery selector for invalid field
		//     //value:Error Message
		//     var errors = {};
		//     //do Validations
		//     if (!_.isEmpty(errors)) {
		//         return errors;
		//     }
		// },
		parse: function(response) {
			var self = this;
			this.yes = i18n.t('CIVICS.COMMON.YES');
			this.no = i18n.t('CIVICS.COMMON.NO');
			this.closed = i18n.t('CIVICS.COMMON.CLOSED');
			this.open = i18n.t('CIVICS.COMMON.OPEN');

			//console.log('model response', response);
			if (Array.isArray(response.data) || this.returnFullModel) {
				return response.data;
			}
			if (Array.isArray(response.data) || this.returnCloneModel) {
				return this.cloneParse(response);
			}
			var retData;
			if (!_.isEmpty(response.data && response.responseStatus)) {
				this.responseStatus = response.responseStatus;
				//console.log('Returned Data:', response.data, JSON.stringify(response.data));
				//Map out the instrument to a standard object.
				var d = response.data;
				var instType = this.instrumentType.toLowerCase();
				
				//Process the service request billing just like the service request.
				if(instType == 'servicerequestbilling'){
					instType = 'servicerequest'
				}

				//*******************GET APPLICANTS***************************
				var applicantData = this.parseApplicants(d, instType);
				var primaryApplicant = applicantData.primaryApplicant;
				var additionalApplicants = applicantData.additionalApplicants;
				//*********************************

				//****************GET ASSOCIATED PROPERTIES***********************
				var associatedProperties = this.parseAssociatedProperties(d, instType);
				//**************************************

				//*****************GET CODE VIOLATIONS*****************
				var violations = [];
				for (var k = 0; d.codeViolations && k < d.codeViolations.length; k++) {
					var violation = {};
					violation.violation = d.codeViolations[k].violation;
					violation.violationDate = d.codeViolations[k].violationDate;
					violation.description = d.codeViolations[k].description;
					violation.status = d.codeViolations[k].violationStatus;
					violation.statusDate = d.codeViolations[k].statusDate;
					violation.comments = d.codeViolations[k].comments;
					violations.push(violation);
				}
				//***************************

				//***********get customer service comment***********
				var custCommentText, custCommentDate, custCommentID;
				if (instType == 'servicerequest') {
					for (var i = 0; d.customerCalls && i < d.customerCalls.length; i++) {
						if (d.customerCalls[i].isPrimaryCaller == 'True') {

							custCommentDate = d.customerCalls[i].callDateTime;
							custCommentText = d.customerCalls[i].comments;
							custCommentID = d.customerCalls[i].id;
						}
					}
				}
				//********************

				//*****get attachment constraint **********
				var type = d.applicationType;
				var attachmentConstraints = [];
				var ePlanTypes = [];

				var filteredConstraints;
				// let isEPlanIntegrated = AvailableFeatures.hasFeature('UAP') && AvailableFeatures.ElectronicPlanForCustomers();
				if (type) {
					attachmentConstraints = type.attachmentConstraints || [];
				}

				filteredConstraints = attachmentConstraints;

				var filterConstraints = false;
				var filterAttachments = false;

				if(AvailableFeatures.ElectronicPlanForCustomers()) {
					if(!AvailableFeatures.ElectronicPlanForCustomersConfig()) {
						filterConstraints = true;
						filterAttachments = true;
					} else {

						if(d.applicationType && d.applicationType.electronicPlanCustomerComments) {
							filterAttachments = true;
						}

						if(d.applicationType && d.applicationType.electronicPlanCustomerSubmittal) {
							filterConstraints = true;
							filterAttachments = true;
						}
					}
				} else {
					filterConstraints = false;
					filterAttachments = false;
				}

				if(filterConstraints) {
					filteredConstraints = attachmentConstraints.filter((item) => !item.isElectronicPlanType);
				}

				if(filterAttachments) {
					ePlanTypes = attachmentConstraints.filter((item) => item.isElectronicPlanType);
				}


				//********************
				if(d.requestType == null) {
					d.requestType = [];
				}



				retData = {
					asset:d.asset,
					requestType:d.requestType,
					constraints: this.parseConstraints(d),
					id: d.id,
					applicationNumber: d.applicationNumber,
					applicationName: d.applicationName,
					// applicationAttachments: attachmentConverter.convertAttachments(d.attachments ? d.attachments : d.applicationAttachments),
					applicationAttachments: d.attachments || d.applicationAttachments,
					attachmentConstraints: filteredConstraints,
					electronicPlanTypes: ePlanTypes,
					details: d.details,
					addedDate: d.addedDateTime,
					electronicPlanCustomerComments: d.applicationType ? d.applicationType.electronicPlanCustomerComments : false,
					electronicPlanCustomerSubmittal: d.applicationType ? d.applicationType.electronicPlanCustomerSubmittal : false,
					apTypeCode: d.applicationType ? d.applicationType.code : d.requestType.type,
					description: d.applicationType ? d.applicationType.description : d.requestType.description,
					portalDescription: d.applicationType ? d.applicationType.portalDescription : d.requestType.portalDescription,
					portalInstructions: d.applicationType ? d.applicationType.portalInstructions : d.requestType.portalInstructions,
					submitInPortal: d.applicationType ? d.applicationType.submitInPortal : d.requestType.submitInPortal,
					additionalSiteType: AvailableFeatures.AdditionalSiteTypeAvailability() && d.applicationType? d.applicationType.associatedSiteType : 3,		//3:address and parcels
					commonID: d.commonId,
					customerCommentID: custCommentID,
					customerCommentText: custCommentText,
					customerCommentDate: custCommentDate,
					theTitle: d.ProjectPhaseName,
					workType: d.workType,
					occupancyType: d.occupancyType,
					squareFootage: d.squareFootage,
					descriptionOfWork: function() {
						if (instType == 'building' || instType == 'customerservice' || instType == 'project' || instType == 'use' || instType == 'planning') {
							return d.comments;
						}
						return '';
					}(),
					declaredValuation: d.declaredValuation,
					calculatedValuation:d.calculatedValuation,
					PhaseNumber: d.phaseNumber ?? d.PhaseNumber,
					subDivision: d.subDivision,
					subDivisionDescription: d.subDivisionDescription,
					ProjectSizeDescription: d.projectSizeDescription ?? d.ProjectSizeDescription,
					proposedStartDate: d.proposedStartDate,
					proposedStopDate: d.proposedStopDate,
					APName: function() {
						if (d.applicationName) {
							return d.applicationName;
						}
						if (d.CaseName) {
							return d.CaseName;
						}
						if (d.APName) {
							return d.APName;
						}
					}(),
					StartDate: d.StartDate,
					EndDate: d.EndDate,
					caseName: d.CaseName,
					steps: d.steps,

					caseSourceDescription: self.processCodeDef(d.Source ?? d.source),
					caseGroupDescription: self.processCodeDef(d.CaseGroup ?? d.caseGroup),
					//licenseCategory: d.applicationType && d.applicationType.description ? d.applicationType.description:'',
					LicenseCategory: d.licenseCategory ?? d.LicenseCategory,
					TypeOfBusiness: d.typeOfBusiness ?? d.TypeOfBusiness,
					BusinessName: d.businessName ?? d.BusinessName,
					DBAName: d.dbaName ?? d.DBAName,
					comments: instType == 'servicerequest' ? custCommentText : d.comments,
					totalFeesCharged: d.totalFeesCharged,
					numberOfPages: d.numberOfPages,
					numberOfPlans: d.numberOfPlans,
					unpaidFees: d.totalUnpaidFees,
					unitOfMeasure: d.unitOfMeasure,
					unitOfMeasureDescription: d.unitOfMeasureDescription,
					totalAmountDueNow: d.totalAmountDueNow,
					payFeesLink: (d.totalUnpaidFees > 0),
					primaryApplicant: primaryApplicant,
					additionalApplicants: additionalApplicants,
					inspectorAssigned: d.inspector && d.inspector != ' ' ? true : false,
					inspectorAssignedDisplay: d.inspector && d.inspector != ' ' ? self.yes : self.no,
					inspectionCompleted: function() {
						if (d.inspectedDateTime) {
							if (utils.dateExists(d.inspectedDateTime) ) {
								return self.yes;
							} else {
								return self.no;
							}
						}
						return '';
					}(),
					//workRequired: d.moreWorkRequired ? d.moreWorkRequired : '',
					requestDate: d.requestDate,
					Spatial: d.Spatial,
					requestCompleted: function() {
						if (d.resolution) {
							if (d.resolution.code.trim().length > 0) {
								return self.yes;
							} else {
								return self.no;
							}
						}
						return '';
					}(),
					resolutionDate: function() {
						if (instType == 'servicerequest') {
							return d.resolvedDateTime
						} else if (instType == 'codeenforcement') {
							return d.ResolvedDateTime;
						}
						return '';
					}(),
					resolutionDescription: function() {
						if (instType == 'servicerequest') {
							return self.processCodeDef(d.resolution);
						} else if (instType == 'codeenforcement') {
							return self.processCodeDef(d.ResolutionCode ?? d.resolutionCode);
						}
						return ''
					}(),
					currentMilestone: d.processState ? d.processState : '',
					processedDate: d.applicationDateTime,
					approvedDate: d.ApprovedDateTime,
					finalDate: d.finalizedDateTime,
					tempCOODate: d.temporaryCOOIssuedDateTime,
					COODate: d.cooIssuedDateTime,
					resolutionCode: function() {
						if (instType == 'servicerequest') {
							return d.resolution ? d.resolution.code : '';
						} else if (instType == 'codeenforcement') {
							return d.ResolutionCode ? d.ResolutionCode.code : ''
						}
						return ''
					}(),
					licenseDate: d.applicationDateTime,
					issuedDate: function() {
						if (d.licenseIssuedDateTime ?? d.LicenseIssuedDateTime) {
							return d.licenseIssuedDateTime ?? d.LicenseIssuedDateTime;
						} else if (d.issuedDateTime) {
							return d.issuedDateTime;
						} else if (d.ApprovedDateTime) {
							return d.ApprovedDateTime;
						}
						return '';
					}(),
					status: function() {
						if (d.statusDescription) {
							return d.statusDescription;
						}
						if (d.resolution && d.resolution.code && d.resolution.code != '' && d.resolution.code != ' ') {
							return self.closed;
						}
						if (instType == 'servicerequest') {
							return self.open;
						}
						return '';
					}(),
					inactiveDate: d.inactiveDateTime ?? d.InactiveDateTime,
					lastRenewalDate: d.lastRenewalDateTime ?? d.LastRenewalDateTime,
					nextRenewalDate: d.nextRenewalDate ?? d.NextRenewalDate,
					additionalSites: associatedProperties,
					location: d.location,
					locationLine1: function(){
						if( d.property && d.property.id > 1 ){
							if( d.property.propertyName && d.property.propertyName != '' && d.property.propertyName != ' ')
								return d.property.propertyName;
							else
								return d.property.propertyId;
						} else if (d.parcel && d.parcel.parcelId && d.parcel.parcelId != '' && d.parcel.parcelId != ' '){ // do not display locationline1 if primary site is parcel
								return '';
						}
						else
							return d.locationLine1;
					}(),
					locationLine2: d.locationLine2,
					locationLine3: d.parcel ? d.parcel.parcelId : '', //only for serviceRequests with Address+Parcel primarySite
					locationLine4: d.Spatial ? 'x: ' + d.Spatial.xCoordinate : '',
					locationLine5: d.Spatial ? 'y: ' + d.Spatial.yCoordinate : '',
					//primarySite:'',
					codeViolations: violations,
					expirationDate: d.expireDateTime,
					graceExpireDate: d.gracePeriodExpireDate,
					activeProfiles: d.ActiveProfiles,
					isOwner: function() {
						for (var i = 0; d.ActiveProfiles && i < d.ActiveProfiles.length; i++) {
							if (d.ActiveProfiles[i].name == "Customer") {

								return true;
							}
						}
						return false;
					}(),
					isProvider: function() {
						for (var i = 0; d.ActiveProfiles && i < d.ActiveProfiles.length; i++) {
							if (d.ActiveProfiles[i].name == "Provider") {
								return true;
							}
						}
						return false;
					}(),
					isPrimaryApplicant: function() {
						var user = view_manager.currentUser();
						return d.primaryContactId == user.get('contactId').id;
					}(),
					resolution: d.resolution,
					resolvedDateTime: d.resolvedDateTime,
					projectPhaseName: d.projectPhaseName,
					CaseName: d.CaseName,
					customerCalls: d.customerCalls,
					addressID: d.address ? d.address.id : 0,
					parcelID: d.parcel ? d.parcel.id : 0,
					PortalStatus : d.PortalStatus,
					isClosedInPortal : d.isClosedInPortal,
					logLinks: function() {
						var currMilestoneLogLinks = d.currentMilestone ? d.currentMilestone.logLinks : '';
						var loglinks = (instType == 'servicerequest') ? d.logLinks : currMilestoneLogLinks;
						var isCust = false;
						var isPublic = false;
						var isProv = false;
						if (!loglinks) {
							loglinks = [];
						}
						for (var i = 0; d.ActiveProfiles && i < d.ActiveProfiles.length; i++) {
							if (d.ActiveProfiles[i].name == "Provider") {
								isProv = true;
								isCust = false;
								isPublic = false;
								break;
							}
							else if (d.ActiveProfiles[i].name == "Customer") {
								isCust = true;
							}
							else if (d.ActiveProfiles[i].name == "Public") {
								isPublic = true;
							}
						}
						if (isCust) {
							isPublic = false;
						}
						for (var i = 0; i < loglinks.length; i++) {

							//do not show this log link if it was already moved to the log link status.
							//always show if the status is empty.
							if ( d.status!= null && d.status.trim() != "" && d.status == loglinks[i].statusCode && instType != 'servicerequest') {
								loglinks.splice(i, 1);
								i--;
							}
							else if (!(loglinks[i].isInCustomerDetails && isCust) &&
								!(loglinks[i].isInPublicDetails && isPublic) &&
								!(loglinks[i].isInMyProjects && self.isInMyProjects) &&
								!(loglinks[i].isInServiceProviderDetails && isProv)
							) {
								loglinks.splice(i, 1);
								i--;
							}
						}
						return loglinks;
					}(),
					workTypeDescription:d.workTypeDescription ? d.workTypeDescription : '',
					occupancyTypeDescription:d.occupancyTypeDescription ? d.occupancyTypeDescription : '',
					licenseCategoryDescription:(d.licenseCategoryDescription ?? d.LicenseCategoryDescription) ? (d.licenseCategoryDescription ?? d.LicenseCategoryDescription) : '',
					typeOfBusinessDescription: self.getDescriptionForCode(d.typeOfBusiness ?? d.TypeOfBusiness, CN.BUSINESS_TYPES()),
					scheduledDateTime: d.scheduledDateTime,
					isElectronicPlanEnabled: d.isElectronicPlanEnabled ? d.isElectronicPlanEnabled : false,
					token: d.token
				};

				attachment_utilities.parseVirusScanStatus(retData.applicationAttachments);
				retData.computedDescription = retData.portalDescription && retData.portalDescription.length>0 ? retData.portalDescription : retData.description;
				if(d.submittedByAuthorizedUser && d.submittedByAuthorizedUser.trim().length > 0){
					retData.submittedByAuthorizedUser = d.submittedByAuthorizedUser;
				}
			}
			return retData;
		},
		cloneParse: function(response) {
			if (!_.isEmpty(response.data && response.responseStatus)) {
				this.responseStatus = response.responseStatus;
				//console.log('Returned Data:', response.data, JSON.stringify(response.data));
				//Map out the instrument to a standard object.
				var d = response.data;
				var instType = this.instrumentType.toLowerCase();

				//clear out status dates from the record so they don't get inadvertantly set when creating the new record
				delete d.expireDateTime;
				delete d.finalizedDateTime;
				delete d.issuedDateTime;
				delete d.temporaryCOOIssuedDateTime;
				delete d.cooIssuedDateTime;
				delete d.addedDateTime;
				delete d.applicationDateTime;
                delete d.licenseIssuedDateTime;
                delete d.LicenseIssuedDateTime;
                delete d.ApprovedDateTime;
                delete d.inactiveDateTime;
                delete d.InactiveDateTime;
                delete d.lastRenewalDateTime;
                delete d.LastRenewalDateTime;
                delete d.nextRenewalDate;
                delete d.NextRenewalDate;
                delete d.gracePeriodExpireDate;

				//****************NORMALIZE ATTRIBUTE CASING***********************
				//The step two forms and summaries read these attributes in PascalCase, but the
				//service serializes camelCase.  parse() normalizes them, and the clone path
				//bypasses parse(), so alias them here or the cloned values render blank.
				d.BusinessName = d.businessName ?? d.BusinessName;
				d.DBAName = d.dbaName ?? d.DBAName;
				d.LicenseCategory = d.licenseCategory ?? d.LicenseCategory;
				d.LicenseCategoryDescription = d.licenseCategoryDescription ?? d.LicenseCategoryDescription;
				d.TypeOfBusiness = d.typeOfBusiness ?? d.TypeOfBusiness;
				d.PhaseNumber = d.phaseNumber ?? d.PhaseNumber;
				d.ProjectSizeDescription = d.projectSizeDescription ?? d.ProjectSizeDescription;
				//**************************************

				//****************GET ASSOCIATED PROPERTIES***********************
				// d.associatedProperties = this.parseAssociatedProperties(d);

				if (instType == 'servicerequest') {
					d.associatedProperties = [];
				}
				$.each(d.associatedProperties, function(index, property) {
					if (property.isLinked === false && (property.address > 1 || property.parcel > 1 || property.asset.id > 1)) {
						property.type = property.typeForDisplay;
						if (property.typeForDisplay.toLowerCase() == 'address') {
							property.id = 'a' + property.address;
						} else if (property.typeForDisplay.toLowerCase() == 'parcel') {
							property.id = 'p' + property.parcel;
						} else { //asset
							property.id = 'c' + property.asset.id;		//use 'c' for 'comp' which makes sense when you look at asset db tables.
							property.locationLine1 = property.description;
						}
					}
				});
				//**************************************
				if (d.requestType) {
					d.comments = d.customerCalls[0].comments;
				}
			}
			return d;

		},
		processCodeDef: function(codeDef){
			//Processes Code Defintions.  This assumes this is a typical code definition with a Code and Description.
			//Returns the Description or a 'value not config' message
			var displayValue = '';
			if( codeDef ){
				if( codeDef.code && codeDef.code.trim().length > 0 ){
					displayValue = codeDef.description ? codeDef.description : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
			}

			return displayValue;
		},
		getDescriptionForCode: function (code, types) {
			if (code != '' && code != ' ' && code != null && types) {
				for (var i = 0; i < types.length; i++) {
					if (types[i].code === code) {
						return types[i].description;
					}
				}
			}
			return null;
		},
		parseApplicants: function(d, instType) {
			var globalConfig = view_manager.globalConfig().toJSON();
			var primaryApplicant = {};
			if (instType != 'servicerequest') {
				primaryApplicant.name = Handlebars.helpers['global:sanitize'](d.primaryContactName || '', { hash: { allowedTags: '' } });
				primaryApplicant.emailAddress = d.primaryContactEMailAddress;
				primaryApplicant.id = d.primaryContactId;
				if( globalConfig.usesApplicantType == 'Show'){
					primaryApplicant.applicantTypeDescription = utils.getApplicantType(instType, Number(d.primaryContactType));
				}

				for(var i = 0; d.applicationContacts && i < d.applicationContacts.length; i++) {
					if(d.applicationContacts[i].contact.id == d.primaryContactId) {
						if( AvailableFeatures.CheckForEffectiveApplicant() ){
							primaryApplicant.isEffective = d.applicationContacts[i].contact.isEffective == 'false' ? false : true;
							primaryApplicant.isEffective = primaryApplicant.isEffective && d.applicationContacts[i].isEffective;
						}
						else{
							primaryApplicant.isEffective = true;
						}

					}
				}
			} else {
				$.each(d.customerCalls, function(index, el) {
					if (el.isPrimaryCaller) {
						primaryApplicant.name = el.contact.identity.firstName + ' ' + el.contact.identity.lastName;
						primaryApplicant.type = ''; //utils.getApplicantType(instType, Number(d.primaryContactType))

					}
				});
			}

			var additionalApplicants = [];
			for (var i = 0; d.applicationContacts && i < d.applicationContacts.length; i++) {
					var contact = {};
					if( globalConfig.usesApplicantType == 'Show'){
						contact.applicantTypeDescription = utils.getApplicantType(instType, d.applicationContacts[i].contactType);
						contact.contactType = d.applicationContacts[i].contactType;

					}
					if( globalConfig.usesCapacity != 'Hide'){
						contact.capacityDescription = this.processCodeDef(d.applicationContacts[i].capacity);
						contact.capacity = d.applicationContacts[i].capacity && d.applicationContacts[i].capacity.code ? d.applicationContacts[i].capacity.code.trim() : '';
					}

					contact.name = d.applicationContacts[i].contact.identity.firstName + ' ';
					contact.name += d.applicationContacts[i].contact.identity.lastName;
					contact.firstname = d.applicationContacts[i].contact.identity.firstName;
					contact.lastname = d.applicationContacts[i].contact.identity.lastName;
					contact.contactId = d.applicationContacts[i].contact.id;
					contact.id = d.applicationContacts[i].id;
					contact.isFavorite = d.applicationContacts[i].isFavorite;
					contact.favoriteId = d.applicationContacts[i].favoriteId;

					//only check effective for 8.8.2007 and 8.7.2007
					if( AvailableFeatures.CheckForEffectiveApplicant() ){
						contact.isEffective = d.applicationContacts[i].contact.isEffective == 'false' ? false : true;
						contact.isEffective = contact.isEffective && d.applicationContacts[i].isEffective;
					}
					else{
						contact.isEffective = true;
					}


					//check to see that the primary applicant is not repeated
					if ((typeof d.applicationContacts[i].isPrimary == 'undefined' || d.applicationContacts[i].isPrimary.toLowerCase() == 'false') ) {
						additionalApplicants.push(contact)
					}
					else{
						if( globalConfig.usesCapacity != 'Hide'){
							primaryApplicant.capacity = contact.capacity;
							primaryApplicant.capacityDescription = contact.capacityDescription;
						}
					}
				}
			return {
				primaryApplicant: primaryApplicant,
				additionalApplicants: additionalApplicants
			};
		},
		parseAssociatedProperties: function(d, instType) {
			var associatedProperties = [];
			for (var j = 0; d.associatedProperties && j < d.associatedProperties.length; j++) {
				if (d.associatedProperties[j].isLinked === false && (d.associatedProperties[j].address > 1 ||
						d.associatedProperties[j].parcel > 1 || (d.associatedProperties[j].asset && d.associatedProperties[j].asset.id > 1))) {
					var addr = {};
					addr.type = d.associatedProperties[j].typeForDisplay;
					addr.addressKey = d.associatedProperties[j].address;
					addr.parcelID = d.associatedProperties[j].parcel;
					addr.assetKey = d.associatedProperties[j].asset ? d.associatedProperties[j].asset.id : 1; //asset associated property in civics was supported on 23.10 above release versions
					addr.associatedID = d.associatedProperties[j].id;
					addr.locationLine1 = d.associatedProperties[j].locationLine1;
					addr.locationLine2 = d.associatedProperties[j].locationLine2;
					if (d.associatedProperties[j].typeForDisplay.toLowerCase() == 'address') {
						addr.address = d.associatedProperties[j].description;
						addr.id = 'a' + d.associatedProperties[j].address;
					} else if (d.associatedProperties[j].typeForDisplay.toLowerCase() == 'parcel') {
						addr.parcel = d.associatedProperties[j].description;
						addr.id = 'p' + d.associatedProperties[j].parcel;
					} else {  //asset
						addr.asset = d.associatedProperties[j].description;
						addr.id = 'c' + d.associatedProperties[j].asset.id;
						addr.locationLine1 = d.associatedProperties[j].description;
					}
					associatedProperties.push(addr);
				}
			}
			return associatedProperties;
		},
		parseConstraints: function(d) {
			//var ret = [];
			var constraints;
			if (this.instrumentType.toLowerCase() != "servicerequest") {
				if (d.currentMilestone && d.currentMilestone.code != '') {
					constraints = d.currentMilestone.constraints
				} else {
					if(d.applicationType) {
						constraints = d.applicationType.constraints;
					}
				}
				return constraint_parser.parseToJSON(constraints, this.instrumentType);
			} else {
				return {};
			}
			//console.log(constraints, constraint_parser.parseToJSON(constraints));
		},
		//sync fires right before a service call. we'll use this to remove the bind on a grid as detail page.
		//grids as detail pages basically use a fake bind to manage teh grid in rhythm. this results in us trying to save detail page data like
		// $InforClient.detailPageFamily.DetailPageName:{
		// 	fakeGridName: [
		// 		{ rowKyey: 0, rowValue: "xyz" },
		// 		{ rowKyey: 1, rowValue: "123" }
		// 	]
		// }
		//What we REALLY need to save however is this:
		// $InforClient.detailPageFamily.DetailPageName: [
		// 	{ rowKyey: 0, rowValue: "xyz" },
		// 	{ rowKyey: 1, rowValue: "123" }
		// ]
		//Since rhythm needs fakeGridName in order to function, and the server needs it to not be there, we'll remove it JUST before it's sent to the server.

		sync: function (method, model, options) {
			if (method == 'create' || method == 'update') {
				var madeChange = false;
				var modelJSON = model.toJSON();

					if (modelJSON.details) {
						$.each(modelJSON.details, (index, el) => {
							var keys = _.keys(el);
							//the data is stored in an attribute like $InforClient.Liferay7Test.liferay7Test or something similar. if we don't find that, we don't have data to save
							if (keys && keys.length > 0) {
								var agencyKey = _.find(keys, k => {
									return k.startsWith('$')
								});
								if (agencyKey) {
									var actualData = el[agencyKey];
									if (actualData) {
										if (actualData.thisIsAGridSoRemoveTheBind === true) {
											delete actualData.thisIsAGridSoRemoveTheBind
											madeChange = true;
										}
										var gridBind = _.keys(actualData);
										if (gridBind.length == 1) {
											modelJSON.details[index][agencyKey] = actualData[gridBind[0]];
										}
									}
								}
							}
						});
						if (madeChange === true) {
							model.set(modelJSON, { silent: true });
						}
					}

					//change it to form-data
					if (model.supportsMultiFiles === true) {
						var formData = new FormData();
						formData = this.parseToFormData(model);
						_.defaults(options || (options = {}), {
							data: formData,
							processData: false,
							contentType: false
						});
					}
			}
			return Backbone.sync(method, model, options);
		},
		parseToFormData: function (model) {
			var modelJSON = model.toJSON();
			var formData = new FormData();

			if (modelJSON.applicationAttachments != null) {
				delete modelJSON.applicationAttachments;
				delete modelJSON.attachmentsCollection;
			}

			var attachmentsCollection = new IpsCollection();
			if (model.attachments && model.attachments.length > 0) {
				model.attachments.forEach((item, i) => {
					formData.append('file', item.file);
					var attachmentModel = new IpsModel()
					attachmentModel.set('Catalog', item.catalog);
					attachmentModel.set('FileName', item.fileName);
					attachmentModel.set('Title', item.title);
					attachmentModel.set('Description', item.description);
					attachmentModel.set('Provider', item.provider);
					if(item.documentType && item.documentType.attributes.length > 0){
							item.documentType.attributes.forEach((attItem, i) => {
								attItem.value = decodeURIComponent(attItem.value);
						});
					}
					attachmentModel.set('documentType', item.documentType);
					attachmentsCollection.add(attachmentModel);
				});
			}

			if (attachmentsCollection && attachmentsCollection.length > 0 ) {
				modelJSON.attachments = attachmentsCollection.toJSON();
			}

			formData.append('data', new Blob([JSON.stringify(modelJSON)], {type: "application/json"}));

			return formData;
		}
	});
});
